const MuiTabs = {
  styleOverrides: {
    flexContainer: {
      justifyContent: 'space-between',
    },
  },
};

export default MuiTabs;
